import { render, staticRenderFns } from "./roof.vue?vue&type=template&id=81f9f3ca&scoped=true"
import script from "./roof.vue?vue&type=script&lang=js"
export * from "./roof.vue?vue&type=script&lang=js"
import style0 from "./roof.vue?vue&type=style&index=0&id=81f9f3ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f9f3ca",
  null
  
)

export default component.exports